import React from 'react'

export default function InicializacaoCotaComponent(props) {

    return (
        <div style={{ textAlign: 'center' }}>
            <p>Confirma a inicialização das cotas?</p>
        </div>

    )
}